import React, { useEffect, useRef, useState } from 'react';
import Api, { apiEventEmitter } from '../../api/Api';
import { PageID } from '../../types/menu';
import styles from './Home.module.scss';
import { Button, Layout, Modal } from 'antd';
import SearchPop from '../../components/features/Search/SearchPop';
import ShoppingCart from '../../components/features/ShoppingCart/ShoppingCart';
import UserProfile from '../../components/features/UserProfile/UserProfile';
import { useLocation, Link, useNavigate, useMatch } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';
import { isEmpty } from 'underscore';
import PricingModal from '../../components/common/Modals/Menu/PricingModal/PricingModal';
import ContactModal from '../../components/common/Modals/Menu/ContactModal/ContactModal';
import FeaturesModal from '../../components/common/Modals/Menu/FeaturesModal/FeaturesModal';
import MaintenanceBanner from '../../components/common/Modals/Maintenance/MaintenanceBanner';
import AdvertisingBanner from '../../components/common/Modals/Advertising/AdvertisingBanner';
import InvitationModal from '../../components/common/Modals/Invtiation/InvitationModal';
import AuthenticateModal from '../../components/features/Login/AuthenticateModal';
import AssociateWithCompanyModal from '../../components/features/Login/AssociateWithCompanyModal';
import SubscriptionExpiredModal from '../../components/common/Modals/Subscription/SubscriptionExpiredModal';
import NotificationModal from '../../components/common/Modals/Menu/NotificationModal/NotificationModal';
import DownloadApiModal from '../../components/common/Modals/Menu/DownloadApiModal/DownloadApiModal';
import useHomeStore from "../../store/homeStore";
import useDatasetStore from "../../store/datasetStore";
import {useInitDatasetBriefs} from "../../queries/useDatasetBriefsQuery";
import useAuthStore from "../../store/authStore";
import {useSilentAuth} from "../../queries/useSilentAuthenticationQuery";
import {useNotificationsBsQuery} from "../../queries/useNotificationsBsQuery";
import LoadModal from "../../components/common/Loading/LoadModal";
import {useSelectedDataset} from "../../components/layout/Header/components/SearchBar";
import Header from "../../components/layout/Header/Header";
import useSearchStore from "../../store/searchStore";

interface IProps {
  children?: React.ReactNode;
}

export default function Home(props: IProps) {
  const showAdvertisingBanner = useHomeStore(state => state.showAdvertisingBanner);
  const showPricingModal = useHomeStore(state => state.showPricingModal);
  const showDownloadApiModal = useHomeStore(state => state.showDownloadApiModal);
  const showContactModal = useHomeStore(state => state.showContactModal);
  const showFeaturesModal = useHomeStore(state => state.showFeaturesModal);
  const showNotifications = useHomeStore(state => state.showNotifications);
  const showAssociateToCompany = useHomeStore(state => state.showAssociateToCompany);
  const showLogin = useHomeStore(state => state.showLogin);
  const showSearch = useHomeStore(state => state.showSearch);
  const showSubscriptionExpiredModal = useHomeStore(state => state.showSubscriptionExpiredModal);
  const notifications = useHomeStore(state => state.notifications);
  const showCart = useHomeStore(state => state.showCart);
  const showUserProfile = useHomeStore(state => state.showUserProfile);
  const showSpectraModal = useHomeStore(state => state.showSpectraModal);

  const setShowSearch = useHomeStore(state => state.setShowSearch);
  const setShowPricingModal = useHomeStore(state => state.setShowPricingModal);
  const setShowFeaturesModal = useHomeStore(state => state.setShowFeaturesModal);
  const setShowContactModal = useHomeStore(state => state.setShowContactModal);
  const setShowNotifications = useHomeStore(state => state.setShowNotifications);
  const setShowDownloadApiModal = useHomeStore(state => state.setShowDownloadApiModal);
  const setShowGetStartedModal = useHomeStore(state => state.setShowGetStartedModal);
  const setShowCart = useHomeStore(state => state.setShowCart);
  const setShowUserProfile = useHomeStore(state => state.setShowUserProfile);
  const setShowAdvertisingBanner = useHomeStore(state => state.setShowAdvertisingBanner);

  const datasetBriefs = useDatasetStore(state => state.datasetBriefs)
  const user = useAuthStore(state => state.user);
  const setSearchId = useSearchStore(state => state.setSearchId)
  const searchId = useSearchStore(state => state.searchId)

  const [, setPageId] = useState<PageID | undefined>('app');
  const [isActivateModalVisible, setIsActivateModalVisible] = useState(false);
  const [activateMessage, setActivateMessage] = useState('');
  const { onChange } = useSelectedDataset((id) => setSearchId(id))

  const navigate = useNavigate();
  const location = useLocation();
  const effectRan = useRef(false);

  const isPaymentSuccessRoute = useMatch({
    path: '/paymentsuccess',
    end: true
  });

  // First Load open url modal
  const pathName = useLocation().pathname.substring(1);
  useEffect(() => {
    const splitPath = pathName.split('/');
    const pageId = splitPath[0].toLocaleLowerCase() as PageID;
    if (pageId === 'metadata' && isEmpty(splitPath[1])) {
      if (!isEmpty(splitPath[1])) {
        setSearchId(splitPath[1]);
      }
      setShowSearch(true);
    }
    if (pageId === 'metadata' && !isEmpty(splitPath[1])) {
      setSearchId(splitPath[1]);
      setShowSearch(true);
    }
    if (pageId === 'pricing') {
      setShowPricingModal(true);
    }
    if (pageId === 'features') {
      setShowFeaturesModal(true);
    }
    if (pageId === 'contact') {
      setShowContactModal(true);
    }
    if (pageId === 'notifications') {
      setShowNotifications(true);
    }
    if (pageId === 'api'){
      setShowDownloadApiModal(true)
    }
  }, []);

  // On page change open or close url modal
  useEffect(() => {
    const pageId = location.pathname.split('/')[1]
    if (pathName === '/' || pageId === '') {
      setShowPricingModal(false);
      setShowSearch(false);
      setShowContactModal(false);
      setShowFeaturesModal(false);
      setShowGetStartedModal(false);
      setShowNotifications(false);
      setShowDownloadApiModal(false);
      return;
    }

    const splitPath = pathName.split('/');

    if (pageId === 'metadata') {
      if (!isEmpty(splitPath[2])) {
        setSearchId(splitPath[2]);
      }
      setShowSearch(true);

      return;
    }

    switch (pageId) {
      case 'pricing':
        setShowPricingModal(true);
        break;

      case 'features':
        setShowFeaturesModal(true);
        break;

      case 'contact':
        setShowContactModal(true);
        break;

      case 'getstarted':
        setShowGetStartedModal(true);
        break;

      case 'notifications':
        setShowNotifications(true);
        break;

      case 'api':
        setShowDownloadApiModal(true);
        break;

      default:
        resetAllModals();
        return;
    }

    function resetOtherModals() {
      setShowPricingModal(false);
      setShowSearch(false);
      setShowContactModal(false);
      setShowFeaturesModal(false);
      setShowGetStartedModal(false);
      setShowNotifications(false);
      setShowDownloadApiModal(false);
    }

    function resetAllModals() {
      resetOtherModals();
    }
  }, [location]);

  useSilentAuth()
  useInitDatasetBriefs()
  useNotificationsBsQuery()

  function onCloseCart() {
    setShowCart(false);
  }

  function goCheckoutPage() {
    onCloseCart();
    setPageId('checkout');
    navigate('checkout');
  }

  function onCloseUserProfile() {
    setShowUserProfile(false);
  }

  function onCloseActivateMessage() {
    setIsActivateModalVisible(false);
    setActivateMessage('');
  }

  const handleCloseAllModals = () => {
    setShowPricingModal(false);
    setShowSearch(false);
    setShowContactModal(false);
    setShowFeaturesModal(false);
    setShowGetStartedModal(false);
    setShowDownloadApiModal(false);
  };

  const handleLogin = React.useCallback(() => {
    (window.top || window).location.assign(
      `${Api.SERVER_DOMAIN}${Api.IISSite}/auth/signin`
    );
  }, []);

  useEffect(() => {
    const handleError = () => {
      if(!isEmpty(user)){
        Modal.confirm({
          title: 'Session Expired',
          content: (
            <div>
              <p>Your session was terminated automatically because we have detected a lack of activity.</p>
              <p>If you wish to continue with metocean-on-demand please sign in again.</p>
            </div>
          ),
          okText: 'Sign In',
          onOk: handleLogin,
          okButtonProps: { style: { margin: '0 auto', display: 'flex', justifyContent: 'center' } },
          cancelButtonProps: { style: { display: 'none' } },
          closable: true,
        });
      }
    };

    apiEventEmitter.on('credentialError', handleError);

    return () => {
      apiEventEmitter.off('credentialError', handleError);
    };
  }, [user]);

  useEffect(() => {
    if (effectRan.current) return;

    if (!isEmpty(searchId) && !isEmpty(datasetBriefs)) {
      onChange(searchId);
      effectRan.current = true;
    }
  }, [searchId, datasetBriefs]);

  return (
    <InvitationModal>
      <Layout className={styles.root}>
        <Header
          advertisingBannerClick={() => {
            if (showAdvertisingBanner === 'true') {
              setShowAdvertisingBanner('false');
            }
            if (showAdvertisingBanner === 'false') {
              setShowAdvertisingBanner('true');
            }
          }}
        />
        <Content>
          <PricingModal
            visible={showPricingModal}
            onHandlePricingModalCancel={() => navigate('/')}
            handleCloseAllModals={handleCloseAllModals}
          />
          <DownloadApiModal
            visible={showDownloadApiModal}
            onHandleDownloadApiModalCancel={() => navigate('/')}
          />
          <ContactModal
            visible={showContactModal}
            onHandleContactModalCancel={() => navigate('/')}
          />
          <FeaturesModal
            visible={showFeaturesModal}
            onHandleFeaturesModalCancel={() => navigate('/')}
            handleCloseAllModals={handleCloseAllModals}
          />
          <NotificationModal
            visible={showNotifications}
            onHandleNotificationModalCancel={() => navigate('/')}
          />
          <Modal
            open={isActivateModalVisible}
            footer={
              <Link to={'/app'}>
                <Button onClick={onCloseActivateMessage}>Ok</Button>
              </Link>
            }
          >
            <p>{activateMessage}</p>
          </Modal>

          <Modal
            closable={false}
            keyboard={false}
            open={isPaymentSuccessRoute !== null}
            title={'Checkout successful'}
            footer={
              <Link to={'/'}>
                <Button>OK</Button>
              </Link>
            }
          >
            {
              'An email with a link to download the data will be sent to you within a few minutes. You will be redirected to the main page.'
            }
          </Modal>
          {showAssociateToCompany.status && <AssociateWithCompanyModal />}
          {showSubscriptionExpiredModal.status && <SubscriptionExpiredModal />}
          {(showLogin || showSpectraModal) && <AuthenticateModal />}
          <SearchPop
            visible={showSearch}
            searchID={(id) => setSearchId(id)}
            onHandleDatasetsModalCancel={() => navigate('/')}
          />
          <div className={styles.bannerContainer}>
            {notifications.length > 0 && <MaintenanceBanner />}
            {showAdvertisingBanner && <AdvertisingBanner />}
          </div>

          {showCart && (
            <ShoppingCart close={onCloseCart} checkout={goCheckoutPage} />
          )}
          {showUserProfile && (
            <UserProfile close={onCloseUserProfile} user={user} />
          )}

          {props.children}
        </Content>
        <LoadModal/>
      </Layout>
    </InvitationModal>
  );
}
